import { render, staticRenderFns } from "./customActivity.vue?vue&type=template&id=5caed1b6"
import script from "./customActivity.vue?vue&type=script&lang=js"
export * from "./customActivity.vue?vue&type=script&lang=js"
import style0 from "./customActivity.vue?vue&type=style&index=0&id=5caed1b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports